export const IDENTIFY = 'iron/analytics/IDENTIFY';
export const SET_GA = 'iron/analytics/SET_GA';
export const PAGEVIEW = 'iron/analytics/PAGEVIEW';
export const TRACK = 'iron/analytics/TRACK';
export const TRANSACTION = 'iron/analytics/TRANSACTION';
export const START_LEANPLUM = 'iron/analytics/START_LEANPLUM';
